(() => {
    if (!customElements.get('loyalty-points-pdp')) {
        customElements.define('loyalty-points-pdp', class LoyaltyPointsPDP extends HTMLElement {
            connectedCallback() {
                this.pointsEl = this.querySelector('[data-loyalty-points]');
                this.points = 0;
                this.rate = this.dataset.rate;
                this.price = this.dataset.variantPrice.replace(',', '.');

                if (!this.pointsEl) return;
                this.init();
            }

            init() {
                this.updatePoints();

                this._onVariantChange = (e) => {
                    this.price = Number((e.detail.variant.price / 100).toFixed(2));
                    this.updatePoints();
                };

                document.addEventListener('variant:change', this._onVariantChange);
            }

            updatePoints() {
                this.countPoints();
                this.setPoints();
                this.updateVisibility();
            }

            countPoints() {
                this.points = this.roundToNearest5(this.price * this.rate / (window?.Shopify?.currency?.rate ?? 1));
            }

            setPoints() {
                this.pointsEl.textContent = String(this.points);
            }

            roundToNearest5(num) {
                return Math.round(num / 5) * 5;
            }

            updateVisibility() {
                this.hidden = this.points <= 0;
            }

            disconnectedCallback() {
                document.removeEventListener('variant:change', this._onVariantChange);
            }
        })
    }
})();